<template>
  <div class="wenxian">
    <div class="top">
      <h2>类型：</h2>
      <span
        v-for="(span, i) in list"
        :key="i"
        @click="handleChange(i, span.num)"
        :class="{ active: index === i }"
        >{{ span.title }}</span
      >
    </div>
    <Item
      class="bottom"
      v-for="item in itemList2"
      :key="item.id"
      :curcer="item.articleId"
      :every="item"
      @itemClick="goDetail"
    ></Item>
    <Paging
      :total="total"
      :curPage="params.pageNo"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Item from "./Item.vue";
import Paging from "@/components/paging";
export default {
  components: {
    Item,
    Paging,
  },
  data() {
    return {
      index: 0,
      // 分页
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      list: [
        {
          title: "全部",
        },
        {
          title: "期刊论文",
          num: 0,
        },
        // {
        // title: "专利",
        // num: 1,
        // },
        {
          title: "专著",
          num: 2,
        },
        // {
        //   title: "文摘",
        //   num: 13,
        // },
        {
          title: "报告",
          num: 6,
        },
      ],
      itemList2: [], // 文献列表
    };
  },
  computed: {
    ...mapState(["hasLogin", "token"]),
  },
  created() {
    this.getUserCollectThesisList(this.params);
  },
  methods: {
    async handleChange(i, num) {
      this.index = i;
      this.params.pageNo = 1;
      this.params.articleType = num
      this.getUserCollectThesisList(this.params);
    },
    handlePager(newPage) {
      this.params.pageNo = newPage;
      this.getUserCollectThesisList(this.params);
      document.documentElement.scrollTop = 0;
    },
    // 文献列表
    async getUserCollectThesisList(data) {
      if(data.articleType === 6){
        const resp = await this.$apis.listServe.getReportCollectList(this.params);
        console.log('打印111',resp)
        if (resp.data) {
          this.total = +resp.data.total;
          this.itemList2 = resp.data.data.map(item=>{
            return {
              ...item,
              title:item.goodsName,
              isCollect:item.publishStatus,
              cover:item.albumPics,
              createName:item.shopName,
              artSummary:item.publishTime,
              articleId:item.id
            }
          })
        }
        return
      }
      const resp = await this.$apis.userServe.getUserCollectThesisList(data);
      if (resp.data) {
        this.total = +resp.data.total;
        this.itemList2 = resp.data.list;
      }
    },
    goDetail(e) {
      let routeUrl;
      if(e.goodsTypeId === '4'){
        console.log(e,'eeeee')
        routeUrl = this.$router.resolve({
          path: "/detail/report",
          query: {
            type: e.goodsTypeId,
            id: e.id,
          },
        });
        window.open(routeUrl.href, "_blank");
        return
      }
      if (e.articleType === 6) {
        routeUrl = this.$router.resolve({
          path: "/dataDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else if (e.type === 3) {
        routeUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else if (e.articleType === 2) {
        routeUrl = this.$router.resolve({
          path: "/concentrationDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        // 跳转静态页面首页
        window.open(`${this.$global.SeoUrl}thesisDetail?type=0&id=${e.articleId}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wenxian {
  width: 1200px;
  .bottom {
    background-color: #fff;
    padding: 37px 49px 19px 37px;
  }
  .top {
    display: flex;
    margin: 40px 0;
    h2 {
      vertical-align: middle;
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
    span {
      margin: 0 10px;
      cursor: pointer;
      &.active {
        color: #0101f3;
      }
    }
  }
}
</style>
